import React from 'react';
import Checkout from '../pages/Checkout';

interface ProtectedCheckoutProps {
  isAuthenticated: boolean;
}

// Checkout belongs to the signed-in account. A guest is sent to registration.
const ProtectedCheckout: React.FC<ProtectedCheckoutProps> = () => {
  return <Checkout />;
};

export default ProtectedCheckout;
